// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.HomeSlider-navigationIcon-YLye3 {
	display: block;
	fill: var(--secondary-foreground);
	height: 36px;
	width: 36px;
	font-size: 36px;
}

.HomeSlider-noMargin-O8tHI {
	margin: 0 auto;
}

.HomeSlider-padding-ldjv_ {
	padding: 0 10px;
}

.HomeSlider-containerTitle-bcqVY {
	color: var(--primary-foreground);
	line-height: normal;
	padding: 0px 15px 0 6px;
	font-weight: bold;
	font-size: 32px;
	margin: 0;
}

.HomeSlider-floatLeft-Ur69e {
	float: left;
}

.HomeSlider-floatRight-huBFH {
	float: right;
}

.HomeSlider-mostViewSwiperContainer-tmV9E {
	position: relative;
}

.HomeSlider-sliderHeadingFlex-TqrkZ {
	display: -webkit-box;
	display: -ms-flexbox;
	display: flex;
	-webkit-box-align: center;
	    -ms-flex-align: center;
	        align-items: center;
	gap: 10px;
	-ms-flex-wrap: wrap;
	    flex-wrap: wrap;
	margin-bottom: 45px;
	-webkit-box-pack: justify;
	    -ms-flex-pack: justify;
	        justify-content: space-between;
}

@media screen and (max-width: 767px) {
	.HomeSlider-sliderHeadingFlex-TqrkZ {
		margin: 0 0 35px;
	}
}`, "",{"version":3,"sources":["webpack://./src/components/Home/HomeSlider/HomeSlider.css"],"names":[],"mappings":"AAAA;CACC,cAAc;CACd,iCAAiC;CACjC,YAAY;CACZ,WAAW;CACX,eAAe;AAChB;;AAEA;CACC,cAAc;AACf;;AAEA;CACC,eAAe;AAChB;;AAEA;CACC,gCAAgC;CAChC,mBAAmB;CACnB,uBAAuB;CACvB,iBAAiB;CACjB,eAAe;CACf,SAAS;AACV;;AAEA;CACC,WAAW;AACZ;;AAEA;CACC,YAAY;AACb;;AAEA;CACC,kBAAkB;AACnB;;AAEA;CACC,oBAAa;CAAb,oBAAa;CAAb,aAAa;CACb,yBAAmB;KAAnB,sBAAmB;SAAnB,mBAAmB;CACnB,SAAS;CACT,mBAAe;KAAf,eAAe;CACf,mBAAmB;CACnB,yBAA8B;KAA9B,sBAA8B;SAA9B,8BAA8B;AAC/B;;AAEA;CACC;EACC,gBAAgB;CACjB;AACD","sourcesContent":[".navigationIcon {\n\tdisplay: block;\n\tfill: var(--secondary-foreground);\n\theight: 36px;\n\twidth: 36px;\n\tfont-size: 36px;\n}\n\n.noMargin {\n\tmargin: 0 auto;\n}\n\n.padding {\n\tpadding: 0 10px;\n}\n\n.containerTitle {\n\tcolor: var(--primary-foreground);\n\tline-height: normal;\n\tpadding: 0px 15px 0 6px;\n\tfont-weight: bold;\n\tfont-size: 32px;\n\tmargin: 0;\n}\n\n.floatLeft {\n\tfloat: left;\n}\n\n.floatRight {\n\tfloat: right;\n}\n\n.mostViewSwiperContainer {\n\tposition: relative;\n}\n\n.sliderHeadingFlex {\n\tdisplay: flex;\n\talign-items: center;\n\tgap: 10px;\n\tflex-wrap: wrap;\n\tmargin-bottom: 45px;\n\tjustify-content: space-between;\n}\n\n@media screen and (max-width: 767px) {\n\t.sliderHeadingFlex {\n\t\tmargin: 0 0 35px;\n\t}\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"navigationIcon": `HomeSlider-navigationIcon-YLye3`,
	"noMargin": `HomeSlider-noMargin-O8tHI`,
	"padding": `HomeSlider-padding-ldjv_`,
	"containerTitle": `HomeSlider-containerTitle-bcqVY`,
	"floatLeft": `HomeSlider-floatLeft-Ur69e`,
	"floatRight": `HomeSlider-floatRight-huBFH`,
	"mostViewSwiperContainer": `HomeSlider-mostViewSwiperContainer-tmV9E`,
	"sliderHeadingFlex": `HomeSlider-sliderHeadingFlex-TqrkZ`
};
module.exports = ___CSS_LOADER_EXPORT___;
